import apiClient from 'apiClient';
import { Nullable } from 'utils/types';
import { AxiosPromise } from 'axios';
import { CommissionTermsValidationResponse, SubmissionRouteType } from './types';

export const assignCommission = (networkId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/assign/network/${networkId}`);
};

export const unassignCommission = (networkId: string, commissionTermId: string): Promise<void> => {
  return apiClient.post(`/api/v1/broker-management/commission-term/${commissionTermId}/unassign/network/${networkId}`);
};

export const changeSubmissionRoute = (
  networkId: string,
  entityId: Nullable<string>,
  submissionRouteType: SubmissionRouteType,
): AxiosPromise<void> => {
  return apiClient.post(`/api/v1/broker-management/update-network/${networkId}/change-preferred-submission-route`, {
    entity_id: entityId,
    submission_route_type: submissionRouteType,
  });
};

export const checkCommissionTermsCoverage = async (networkId: string): Promise<CommissionTermsValidationResponse> => {
  const response = await apiClient.get(`api/v1/broker-management/commission-term/coverage/network/${networkId}`);
  return response.data;
};
